<script setup lang="ts">
defineProps<{ count: number | null }>()

const open = defineModel<boolean>({ required: true })
</script>

<template>
  <v-dialog v-model="open" max-width="420" persistent>
    <v-card class="pa-3 pt-6">
      <v-card-title>Quantities imported</v-card-title>
      <v-card-text>
        <p>
          <strong>{{ count ?? 0 }}</strong> row(s) were uploaded to the server.
        </p>
        <p class="text-medium-emphasis mt-2">
          Please verify this matches the number of rows in your spreadsheet.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" class="text-none" @click="open = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
